export const emitterProps = {
  wishlist: {
    add: 'wishlist:add',
    remove: 'wishlist:remove',
  }
}

class GlobalEmitter {
  emit (name: string, payload = {}) {
    const event = new CustomEvent(name, {
      detail: payload
    })
    document.dispatchEvent(event)
  }

  on (name: string, callback: (payload: any) => void) {
    document.addEventListener(name, (e) => {
      // @ts-ignore
      callback(e.detail)
    })
  }

  off (name: string, callback: (payload: object) => void) {
    document.removeEventListener(name, callback)
  }
}

export const globalEmitter = new GlobalEmitter()
